/**
 * @fileoverview gRPC-Web generated client stub for logepb
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v4.23.4
// source: external/log/log.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var xcommon_log_pb = require('../../xcommon/log_pb.js')
const proto = {};
proto.logepb = require('./log_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.logepb.LogServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.logepb.LogServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.ListOpLogParamsReq,
 *   !proto.xcommon.ListOpLogParamsResp>}
 */
const methodDescriptor_LogService_ListOpLogParams = new grpc.web.MethodDescriptor(
  '/logepb.LogService/ListOpLogParams',
  grpc.web.MethodType.UNARY,
  xcommon_log_pb.ListOpLogParamsReq,
  xcommon_log_pb.ListOpLogParamsResp,
  /**
   * @param {!proto.xcommon.ListOpLogParamsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_log_pb.ListOpLogParamsResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.ListOpLogParamsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.ListOpLogParamsResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.ListOpLogParamsResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.logepb.LogServiceClient.prototype.listOpLogParams =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/logepb.LogService/ListOpLogParams',
      request,
      metadata || {},
      methodDescriptor_LogService_ListOpLogParams,
      callback);
};


/**
 * @param {!proto.xcommon.ListOpLogParamsReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.ListOpLogParamsResp>}
 *     Promise that resolves to the response
 */
proto.logepb.LogServicePromiseClient.prototype.listOpLogParams =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/logepb.LogService/ListOpLogParams',
      request,
      metadata || {},
      methodDescriptor_LogService_ListOpLogParams);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.ListOpLogReq,
 *   !proto.xcommon.ListOpLogResp>}
 */
const methodDescriptor_LogService_ListOpLog = new grpc.web.MethodDescriptor(
  '/logepb.LogService/ListOpLog',
  grpc.web.MethodType.UNARY,
  xcommon_log_pb.ListOpLogReq,
  xcommon_log_pb.ListOpLogResp,
  /**
   * @param {!proto.xcommon.ListOpLogReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_log_pb.ListOpLogResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.ListOpLogReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.ListOpLogResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.ListOpLogResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.logepb.LogServiceClient.prototype.listOpLog =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/logepb.LogService/ListOpLog',
      request,
      metadata || {},
      methodDescriptor_LogService_ListOpLog,
      callback);
};


/**
 * @param {!proto.xcommon.ListOpLogReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.ListOpLogResp>}
 *     Promise that resolves to the response
 */
proto.logepb.LogServicePromiseClient.prototype.listOpLog =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/logepb.LogService/ListOpLog',
      request,
      metadata || {},
      methodDescriptor_LogService_ListOpLog);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.ListThirdpartyLogParamsReq,
 *   !proto.xcommon.ListThirdpartyLogParamsResp>}
 */
const methodDescriptor_LogService_ListThirdpartyParams = new grpc.web.MethodDescriptor(
  '/logepb.LogService/ListThirdpartyParams',
  grpc.web.MethodType.UNARY,
  xcommon_log_pb.ListThirdpartyLogParamsReq,
  xcommon_log_pb.ListThirdpartyLogParamsResp,
  /**
   * @param {!proto.xcommon.ListThirdpartyLogParamsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_log_pb.ListThirdpartyLogParamsResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.ListThirdpartyLogParamsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.ListThirdpartyLogParamsResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.ListThirdpartyLogParamsResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.logepb.LogServiceClient.prototype.listThirdpartyParams =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/logepb.LogService/ListThirdpartyParams',
      request,
      metadata || {},
      methodDescriptor_LogService_ListThirdpartyParams,
      callback);
};


/**
 * @param {!proto.xcommon.ListThirdpartyLogParamsReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.ListThirdpartyLogParamsResp>}
 *     Promise that resolves to the response
 */
proto.logepb.LogServicePromiseClient.prototype.listThirdpartyParams =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/logepb.LogService/ListThirdpartyParams',
      request,
      metadata || {},
      methodDescriptor_LogService_ListThirdpartyParams);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.ListThirdpartyLogReq,
 *   !proto.xcommon.ListThirdpartyLogResp>}
 */
const methodDescriptor_LogService_ListThirdpartyLog = new grpc.web.MethodDescriptor(
  '/logepb.LogService/ListThirdpartyLog',
  grpc.web.MethodType.UNARY,
  xcommon_log_pb.ListThirdpartyLogReq,
  xcommon_log_pb.ListThirdpartyLogResp,
  /**
   * @param {!proto.xcommon.ListThirdpartyLogReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_log_pb.ListThirdpartyLogResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.ListThirdpartyLogReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.ListThirdpartyLogResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.ListThirdpartyLogResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.logepb.LogServiceClient.prototype.listThirdpartyLog =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/logepb.LogService/ListThirdpartyLog',
      request,
      metadata || {},
      methodDescriptor_LogService_ListThirdpartyLog,
      callback);
};


/**
 * @param {!proto.xcommon.ListThirdpartyLogReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.ListThirdpartyLogResp>}
 *     Promise that resolves to the response
 */
proto.logepb.LogServicePromiseClient.prototype.listThirdpartyLog =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/logepb.LogService/ListThirdpartyLog',
      request,
      metadata || {},
      methodDescriptor_LogService_ListThirdpartyLog);
};


module.exports = proto.logepb;

